import { getEnvRequired } from '../../shared/utilities/env';

import { DossierId } from '../dossier/types';
import { ApiClient } from '../shared/api/client';

import {
    serializePhoneCallsFromAPI,
    serializePhoneCallTokenFromApi,
    serializePhoneCallSummaryMailFromAPI,
} from './serializers';
import {
    PhoneCallTokenJSONAPIResponse,
    PhoningMarkets,
    DossierPhoneCallApi,
    JsonApiResponse,
    PhoneCallSummaryMailJSONAPIResponse,
} from './types';

const REQUEST_MANAGER_API_URL = getEnvRequired('REQUEST_MANAGER_API_URL');

const apiClient = new ApiClient(true);

export async function createPhoneCallApi(dossierId: DossierId, language: PhoningMarkets) {
    const response = await apiClient.post<PhoneCallTokenJSONAPIResponse>(
        `${REQUEST_MANAGER_API_URL}/dossier/${dossierId}/phone-call`,
        JSON.stringify({ 'dossier-id': dossierId, language }),
    );
    return serializePhoneCallTokenFromApi(response);
}

export async function startRecordingApi(phoneCallId: number) {
    return await apiClient.post(
        `${REQUEST_MANAGER_API_URL}/phone-calls/${phoneCallId}/recordings/start`,
        '',
    );
}

export async function pauseRecordingApi(phoneCallId: number) {
    return await apiClient.post(
        `${REQUEST_MANAGER_API_URL}/phone-calls/${phoneCallId}/recordings/pause`,
        '',
    );
}

export async function resumeRecordingApi(phoneCallId: number) {
    return await apiClient.post(
        `${REQUEST_MANAGER_API_URL}/phone-calls/${phoneCallId}/recordings/resume`,
        '',
    );
}

export async function retryTranscriptApi(dossierId: DossierId, dossierPhoneCallId: string) {
    return await apiClient.post(
        `${REQUEST_MANAGER_API_URL}/dossier/${dossierId}/phone-call/${dossierPhoneCallId}/request-transcript-regeneration`,
        '',
    );
}

export async function retrySummaryApi(dossierId: DossierId, dossierPhoneCallId: string) {
    return await apiClient.post(
        `${REQUEST_MANAGER_API_URL}/dossier/${dossierId}/phone-call/${dossierPhoneCallId}/request-summary-regeneration`,
        '',
    );
}

export async function getPhoneCalls(dossierId: DossierId) {
    const response = (await apiClient.get(
        `${REQUEST_MANAGER_API_URL}/dossier/${dossierId}/phone-calls`,
    )) as JsonApiResponse<DossierPhoneCallApi>;

    const phoneCallsData = response.data.map((resource) => ({
        ...resource.attributes,
        dossierPhoneCallId: resource.id,
    }));

    return serializePhoneCallsFromAPI(phoneCallsData);
}

export async function generateSummaryMailApi(dossierId: DossierId, dossierPhoneCallId: string) {
    const response = (await apiClient.get(
        `${REQUEST_MANAGER_API_URL}/dossier/${dossierId}/phone-call/${dossierPhoneCallId}/generate-summary-mail`,
    )) as PhoneCallSummaryMailJSONAPIResponse;

    return serializePhoneCallSummaryMailFromAPI(response);
}
